module.exports = __webpack_public_path__ + "static/media/mc_lid_action_vector.a75e3d96.svg";